import type { PendingInvitation } from "@/entities/invitation";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getPendingInvitations } from "./api";

interface Args extends Partial<UseQueryOptions<PendingInvitation[]>> {}

export const usePendingInvitationsQuery = (args: Args = {}) =>
  useQuery<PendingInvitation[]>({
    /** Answered from the user's email alone, so it is not keyed by the active company. */
    queryKey: ["invitation", "pending"],
    queryFn: getPendingInvitations,
    ...args,
  });
